module.exports = __webpack_public_path__ + "img/boite-de-vitesse.e0c266f0.png";